import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Img from "gatsby-image"

const FeatureCard = () => {
  return (
    <ul className="feature-card">
      <li className="lg:w-1/4 w-full ">
        <div className="inner-card">
          <p>
            Deals on total <br />
            100+ stores
          </p>
        </div>
      </li>
      <li className="lg:w-1/4 w-full mt-10 lg:mt-0">
        <div className="inner-card">
          <p>
            Special offers for <br />
            the most active users.
          </p>
        </div>
      </li>
      <li className="lg:w-1/4 w-full mt-10 lg:mt-0">
        <div className="inner-card">
          <p>
            hassle-free <br />
            redemption
          </p>
        </div>
      </li>
    </ul>
  )
}

export default FeatureCard
